import { ShieldUserIcon as icon } from "lucide-react"
import create from "./permissions.create"
import edit from "./permissions.edit"
import list from "./permissions.list"

const crud = (permissions: Record<string, string[]>) => ({
  name: "permissions",
  options: { label: "Permissions" },
  list:
    "permissions" in permissions && permissions.permissions.includes("list")
      ? list
      : undefined,
  create:
    "permissions" in permissions && permissions.permissions.includes("create")
      ? create
      : undefined,
  edit:
    "permissions" in permissions && permissions.permissions.includes("edit")
      ? edit
      : undefined,
  icon,
})

export default crud
